import { Box, Typography } from '@mui/material';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';
import { Link } from 'react-router-dom';

const TestKitsValidatedOver18Warning = () => {
  const { theme } = useThemeContext();
  return (
    <Box
      sx={{
        alignItems: 'center',
        background: theme.custom.components.commonTestKitActivation.over18Alert.container.backgroundColor,
        borderRadius: '10px',
        display: 'flex',
        justifyContent: 'center',
        margin: '0 auto 21px',
        maxWidth: '600px',
        padding: '10px',
      }}
    >
      <Box>
        <Typography
          variant="body2"
          sx={{
            ml: 1,
            color: theme.custom.components.commonTestKitActivation.over18Alert.container.typography.firstMessage.color,
          }}
        >
          Remember tests are currently validated for 18 and over. Please ensure that everyone taking the test is at
          least 18 years of age.
        </Typography>
        <Typography
          variant="body2"
          sx={{
            ml: 1,
            color: theme.custom.components.commonTestKitActivation.over18Alert.container.typography.link.color,
            fontSize: '13px',
            marginTop: '6px',
          }}
        >
          If needed, please read our{' '}
          <Link to="/tos.html" target="_blank" style={{ textDecoration: 'none' }}>
            <span
              style={{
                fontWeight: 'bold',
                color: theme.custom.components.commonTestKitActivation.over18Alert.container.typography.link.color,
                fontSize: '13px',
                marginTop: '6px',
              }}
            >
              Terms of Service
            </span>
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default TestKitsValidatedOver18Warning;
